import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: 'Dói?',
      answer: 'O procedimento é confortável. A sensação é leve e rápida, muito mais tranquila que cera ou métodos tradicionais.'
    },
    {
      question: 'Quantas sessões são necessárias?',
      answer: 'O número varia conforme a região, tipo de pelo e resposta individual. Por isso, a avaliação gratuita é fundamental.'
    },
    {
      question: 'É realmente seguro?',
      answer: 'Sim. O tratamento é realizado com tecnologia avançada, respeitando seu tom de pele e características individuais.'
    },
    {
      question: 'Em quanto tempo vejo resultados?',
      answer: 'Muitos clientes percebem redução já nas primeiras sessões.'
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 xl:py-28 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black text-center mb-10 sm:mb-12 lg:mb-16">
          Perguntas Frequentes
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-md overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full px-6 sm:px-8 py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="text-base sm:text-lg md:text-xl font-bold text-black pr-4">
                  {faq.question}
                </span>
                <div className={`w-8 h-8 flex items-center justify-center flex-shrink-0 bg-[#E91E63] rounded-full transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-white text-xl"></i>
                </div>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}
              >
                <div className="px-6 sm:px-8 pb-6">
                  <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
